import Vue from 'vue'
import Sentry from 'sentry'

class AlertController {
  constructor() {
    this.title = '核销二维码'
    this.QRCodeBlobURL = null
    this.text = ''
    this.code = ''
    this.writeOffCallback = () => {}

    return this
  }

  async generateQRCodeBlobURL() {
    if (this.QRCodeBlobURL) {
      return this.QRCodeBlobURL
    }

    const QRCodeModule = (await import('qrcodejs')).default
    const QRCodeBlobURL = await new Promise(async resolve => {
      try {
        const div = document.createElement('div')

        // eslint-disable-next-line
        new QRCodeModule(div, {
          text: this.text,
          width: 184,
          height: 184
        })

        div.firstElementChild.toBlob(blob => {
          resolve(window.URL.createObjectURL(blob))
        })
      } catch (err) {
        Sentry.captureException(err, 'QRCode Error')
      }
    })

    this.QRCodeBlobURL = QRCodeBlobURL
    return QRCodeBlobURL
  }

  async show(args) {
    const self = this
    const opt = {}

    if (typeof args === 'string') {
      opt.text = args
    } else {
      Object.assign(opt, args)
    }

    if (opt.text !== self.text) {
      window.URL.revokeObjectURL(self.QRCodeBlobURL)
      self.QRCodeBlobURL = null
    }

    self.title = 'title' in opt ? opt.title : self.title
    self.text = 'text' in opt ? opt.text : self.text
    self.code = 'code' in opt ? opt.code : self.code
    self.writeOffCallback = 'writeOffCallback' in opt ? opt.writeOffCallback : self.writeOffCallback

    await self.generateQRCodeBlobURL()
    let baseString = '核销'
    if(args.activity_id !== undefined){
      if(+args.activity_id === 268184){
        baseString = '签到'
        self.title = '签到二维码'
      }
    }

    Vue.$vux.alert.show({
      title: self.title,
      content: [
        '<p style="margin:.3rem 0">请向机构人员出示进行扫码'+baseString+'</p>',
        `<img src="${self.QRCodeBlobURL}" alt="qrcode.png" style="width:8rem;height:8rem;margin:0.5rem 0 0;" />`,
        self.code
          ? `<p style="margin-top:.4rem;font-size:0.8rem">${baseString}码：<b>${self.code}</b></p>`
          : '',
        process.env.NODE_ENV === 'development'
          ? `<a href="${self.text}" style="display:block;color:inherit;margin-top:0.4rem">${self.text}</a>`
          : ''
      ].join(''),
      onShow() {
      },
      onHide() {
      }
    })
  }
}

const qrcodeDialogPlugin = Vue => {
  Vue.mixin({
    methods: {
      $showQrcodeDialog(args) {
        if (window.__QRCodeAlertInstance) {
          return window.__QRCodeAlertInstance.show(args)
        }

        window.__QRCodeAlertInstance = new AlertController()
        window.__QRCodeAlertInstance.show(args)
      }
    }
  })
}

export default qrcodeDialogPlugin